import React from "react"
import CategoryModel from "sdk/CategoryModel"
import { Link } from "react-router-dom"
import { Icon } from "semantic-ui-react"
import shop from "shop/shop"
import _ from "lodash"
import settingStore from "stores/settingStore"

export default class CategoryModelArnold extends CategoryModel {
  constructor( data ) {
    super( data )
    this.update()
  }

  update() {
    // console.log("AC", this)
    const mode = settingStore.get( "orderMode" )
    // console.log( this.meta )
    this.active = true

    if ( this.meta.submeta && this.meta.submeta.fields && this.meta.submeta.fields ) {
      const containsPreorder = this.meta.submeta.fields.vororder && this.meta.submeta.fields.vororder.includes( "true" )
      const containsSofortorder = this.meta.submeta.fields.sofortorder && this.meta.submeta.fields.sofortorder.includes( "true" )
  
      switch ( mode ) {
        case "MODE_AVAILABLE":
          this.active = containsSofortorder
          break;

        case "MODE_PREORDER":
          this.active = containsPreorder
          break;
      }
    }

    //
    // //SORT THIS CATEGORY ONLY
    // if ( this.meta.fields && this.meta.fields.vororder ) {
    //   const countPreorder = this.meta.fields.vororder.values[ "true" ]
    //   const countAvailable = this.meta.fields.vororder.values[ "false" ]
    //
    //   switch ( mode ) {
    //     case "MODE_AVAILABLE":
    //       this.active = countAvailable > 0
    //       break;
    //
    //     case "MODE_PREORDER":
    //       this.active = countPreorder > 0
    //       break;
    //   }
    //   // console.log( mode, this.active, { countPreorder, countAvailable } )
    // }
  }

}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/shop/CategoryModel.js